import primaryButton from '../../../../primary-button';

const primary = (params) => primaryButton.solidIcon.background.default.primary(params);

export default primary;
